var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-83c72545.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-26b86ff1.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M2.724 4h26.56c1.463 1.9 1.883 3.909 1.883 3.909.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-.415 1.985-1.858 3.876H2.725C1.282 26.11.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .416-1.984 1.858-3.875Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 25.333a9.333 9.333 0 1 0 0-18.666 9.333 9.333 0 0 0 0 18.666Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M14.122 8.393c.46-.113.93-.184 1.408-.212a.5.5 0 0 1 .06.998 6.825 6.825 0 0 0-1.229.185.5.5 0 0 1-.239-.97Zm4.888.373a7.775 7.775 0 0 0-1.36-.425.5.5 0 1 0-.21.978c.407.087.804.211 1.186.37a.5.5 0 1 0 .384-.923Zm1.874 1.11a7.88 7.88 0 0 1 1.028.985.5.5 0 0 1-.755.656 6.879 6.879 0 0 0-.897-.86.5.5 0 1 1 .624-.781ZM23.576 14a7.778 7.778 0 0 0-.488-1.338.5.5 0 0 0-.904.426c.177.375.319.765.425 1.167a.5.5 0 1 0 .967-.255Zm.256 2.145a7.76 7.76 0 0 1-.155 1.415.5.5 0 1 1-.98-.198c.082-.404.127-.817.135-1.235a.5.5 0 1 1 1 .018Zm-1.614 4.619c.29-.378.544-.78.76-1.204a.5.5 0 1 0-.89-.455 6.84 6.84 0 0 1-.664 1.05.5.5 0 1 0 .794.609Zm-1.536 1.516a7.835 7.835 0 0 1-1.214.745.5.5 0 0 1-.443-.897 6.824 6.824 0 0 0 1.059-.65.5.5 0 1 1 .598.802Zm-3.264 1.424a7.878 7.878 0 0 1-1.418.128.5.5 0 1 1 0-1c.419 0 .832-.037 1.238-.111a.5.5 0 0 1 .18.983ZM12.105 9.202a7.81 7.81 0 0 0-1.166.819.5.5 0 1 0 .646.763 6.848 6.848 0 0 1 1.017-.714.5.5 0 0 0-.498-.868Zm-3.29 3.674a7.87 7.87 0 0 1 .684-1.248.5.5 0 0 1 .83.558 6.82 6.82 0 0 0-.598 1.09.5.5 0 0 1-.917-.4Zm-.573 2.033a7.898 7.898 0 0 0-.068 1.44.5.5 0 1 0 1-.044 6.894 6.894 0 0 1 .06-1.257.5.5 0 0 0-.992-.139Zm.885 4.852a7.794 7.794 0 0 1-.568-1.307.5.5 0 0 1 .95-.313c.13.395.295.776.495 1.139a.5.5 0 0 1-.877.48Zm1.285 1.729c.333.339.697.647 1.086.921a.5.5 0 0 0 .575-.818 6.873 6.873 0 0 1-.948-.804.5.5 0 1 0-.713.7Zm4.358 2.247a7.776 7.776 0 0 1-1.381-.35.5.5 0 0 1 .333-.942c.39.137.792.24 1.204.305a.5.5 0 1 1-.156.987Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagBlz = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagBlz_default = SvgFlagBlz;
export {
  FlagBlz_default as default
};
